import React, { Component } from "react";
import { connect } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';

/* for "axios" request cancelation */
import axios from 'axios';

/* Helpers */
import { history } from '../../../helpers/history';

/* Services */
import ParentService from "../../../services/parent.service";

/* Ant Design */
import { Typography, Spin, Row, Col, Image, Card, Tag, Button, Modal } from 'antd';

/* for "axios" request cancelation check variable */
let source;

class PatientGameDetail extends Component {
    constructor(props) {
        super(props);
        this.getParentGameDetail = this.getParentGameDetail.bind(this);
        this.buyGame = this.buyGame.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleOk = this.handleOk.bind(this);

        history.listen((location) => {
            props.gameDispatch.clearGames();
        });

        this.state = {
            modalVisible: false,
            modalConfirmLoading: false
        };
    }

    componentDidMount() {
        /* Component Mount olurken source'a token iletilir */
        source = axios.CancelToken.source();

        this.props.gameDispatch.clearGames();

        if (this.props.match.params.gameId) {
            this.getParentGameDetail();
        }
    }

    getParentGameDetail() {
        this.props.gameDispatch.setLoading(true);

        ParentService.getGameDetail(this.props.match.params.gameId, source.token)
            .then(
                (res) => {
                    this.props.gameDispatch.setGameObject(res.data);
                    this.props.gameDispatch.setLoading(false);
                },
                error => {
                    const resMessage =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    /* Request cancel edildiğinde message olarak 'Cancel' dönüyor. Hata bildirimi verilmesini engellemek için */
                    if (resMessage !== 'Cancel') {
                        toast.error(resMessage);
                    }
                    this.props.gameDispatch.setLoading(false);
                }
            )
    }

    buyGame(gameId) {
        this.setState({ modalConfirmLoading: true });
        ParentService.buyGame(gameId).then(
            (res) => {
                toast.success(res.data.successMessage, { autoClose: 3000 });
                this.clearTimer = setTimeout(() => {
                    this.props.history.push("/parent/games");
                }, 3000);
                this.setState({ modalConfirmLoading: false });
            },
            error => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                toast.error(resMessage);
                this.setState({ modalConfirmLoading: false });
            }
        )
    }

    handleCancel() {
        if (!this.state.modalConfirmLoading) {
            this.setState({ modalVisible: false })
        }
    }

    handleOk(e, game) {
        this.setState({ modalConfirmLoading: true });
        this.buyGame(game._id);
        this.setState({ modalVisible: false });
    }

    componentWillUnmount() {
        /* Component Unmount edilirken cancel triggerı tetiklenir */
        if (source) {
            source.cancel();
        }

        clearTimeout(this.clearTimer);
    }

    render() {
        return (
            <div>
                {!this.props.game.loading && this.props.gameObject &&
                    <div>
                        <Typography.Title level={2} style={{ textAlign: 'center' }}>{this.props.gameObject.OyunAdi}</Typography.Title>
                        <Row gutter={[8, 32]} style={{ marginTop: '5vh' }}>
                            {/* Game Photo */}
                            <Col sm={24} md={8} lg={8} xl={8} xxl={8}>
                                <Image
                                    preview={false}
                                    width={'100%'}
                                    src={this.props.gameObject.OyunID ? this.props.gameObject.OyunID.PhotoLink : this.props.gameObject.PhotoLink}
                                    alt={this.props.gameObject.OyunID ? this.props.gameObject.OyunID.OyunAdi : this.props.gameObject.OyunAdi}
                                    fallback="data:image/png;base64,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"
                                />
                            </Col>

                            <Col sm={24} md={16} lg={16} xl={16} xxl={16}>
                                <Row gutter={[8, 32]} style={{ marginTop: '5vh' }}>
                                    {this.props.gameObject.OyunID ?
                                        /* Satın Alınan Oyunlar */
                                        <Card.Meta
                                            title={
                                                <Typography.Title level={4}>
                                                    <b>İsim: </b>
                                                    {this.props.gameObject.OyunID.OyunAdi ? this.props.gameObject.OyunID.OyunAdi : 'İsim Bulunamadı!'}
                                                </Typography.Title>
                                            }
                                            description={
                                                <Typography>
                                                    <Typography.Title level={5}>
                                                        <b>Açıklama: </b>
                                                        {this.props.gameObject.OyunID.OyunAciklama ? this.props.gameObject.OyunID.OyunAciklama : 'Oyun Açıklaması Bilgisine Ulaşılamadı!'}
                                                    </Typography.Title>
                                                    {this.props.gameObject.SatinAlmaTarihi &&
                                                        <Typography.Title level={5}>
                                                            <b>Satın Alma Tarihi: </b>
                                                            {moment(new Date(this.props.gameObject.SatinAlmaTarihi)).format('LL')}
                                                        </Typography.Title>
                                                    }
                                                </Typography>
                                            }
                                            style={{ paddingLeft: '5vh' }}
                                        />
                                        :
                                        /* Demo Oyunlar */
                                        <Card.Meta
                                            title={
                                                <Typography.Title level={4}>
                                                    <b>İsim: </b>
                                                    {this.props.gameObject.OyunAdi ? this.props.gameObject.OyunAdi : 'İsim Bulunamadı!'}
                                                </Typography.Title>
                                            }
                                            description={
                                                <Typography.Title level={4}>
                                                    <b>Açıklama: </b>
                                                    {this.props.gameObject.OyunAciklama ? this.props.gameObject.OyunAciklama : 'Oyun Açıklaması Bilgisine Ulaşılamadı!'}
                                                </Typography.Title>
                                            }
                                            style={{ paddingLeft: '5vh' }}
                                        />
                                    }
                                </Row>
                                {/* Kategori */}
                                <Row gutter={[8, 12]} style={{ width: '100%', marginTop: '5vh', paddingLeft: '5vh' }}>
                                    <Col span={24}>
                                        {this.props.gameObject.OyunID ?
                                            <Tag color="volcano" style={{ whiteSpace: "normal", height: 'auto', marginBottom: '10px' }}>
                                                {this.props.gameObject.OyunID.KategoriID ? this.props.gameObject.OyunID.KategoriID.KategoriAdi : 'Kategori Bilgisine Ulaşılamadı!'}
                                            </Tag>
                                            :
                                            <Tag color="volcano" style={{ whiteSpace: "normal", height: 'auto', marginBottom: '10px' }}>
                                                {this.props.gameObject.KategoriID ? this.props.gameObject.KategoriID.KategoriAdi : 'Kategori Bilgisine Ulaşılamadı!'}
                                            </Tag>
                                        }
                                    </Col>
                                    {/* Egzersiz Tipi */}
                                    <Col span={24}>
                                        {this.props.gameObject.OyunID ?
                                            <Tag color="magenta" style={{ whiteSpace: "normal", height: 'auto', marginBottom: '10px' }}>
                                                {this.props.gameObject.OyunID.EgzersizTipiID ? this.props.gameObject.OyunID.EgzersizTipiID.EgzersizTipiAdi : 'Egzersiz Tipi Bilgisine Ulaşılamadı!'}
                                            </Tag>
                                            :
                                            <Tag color="magenta" style={{ whiteSpace: "normal", height: 'auto', marginBottom: '10px' }}>
                                                {this.props.gameObject.EgzersizTipiID ? this.props.gameObject.EgzersizTipiID.EgzersizTipiAdi : 'Egzersiz Tipi Bilgisine Ulaşılamadı!'}
                                            </Tag>
                                        }
                                    </Col>
                                    <Col span={24}>
                                        {
                                            this.props.gameObject.Free === true ?
                                                <Tag color="green">Ücretsiz</Tag>
                                                :
                                                <Tag color="red">Ücretli</Tag>
                                        }
                                    </Col>
                                </Row>
                                {/* Eğer Alınmamış ise Oyun Satın Alımı */}
                                {(!this.props.gameObject.OyunID && !this.props.gameObject.Free) &&
                                    <Row gutter={[8, 12]} style={{ width: '100%', marginTop: '5vh', paddingLeft: '5vh' }}>
                                        <Col span={4}>
                                            <Button type='primary' onClick={() => this.setState({ modalVisible: this.props.gameObject.OyunAdi })} style={{ width: '90%' }} block>Satın Al</Button>
                                            <Modal
                                                title={
                                                    <div>
                                                        <Typography.Text type="success">Oyunu Satın Al!</Typography.Text>
                                                    </div>
                                                }
                                                visible={this.state.modalVisible === this.props.gameObject.OyunAdi}
                                                onOk={(e) => this.handleOk(e, this.props.gameObject)}
                                                confirmLoading={this.state.modalConfirmLoading}
                                                onCancel={() => this.handleCancel()}
                                            >
                                                <p>
                                                    <b>"{this.props.gameObject.OyunAdi}"</b> isimli oyunu satın almak istediğinize emin misiniz?
                                                </p>
                                            </Modal>
                                        </Col>
                                    </Row>
                                }
                            </Col>
                        </Row>
                    </div>
                }
                {this.props.game.loading &&
                    <div style={{ textAlign: 'center', marginTop: '5vh' }}>
                        <Spin />
                    </div>
                }
            </div>
        )
    }
}

const mapState = (state) => ({
    game: state.game,
    gameObject: state.game.gameObject,
});

const mapDispatch = (dispatch) => ({
    gameDispatch: dispatch.game,
});

export default connect(mapState, mapDispatch)(PatientGameDetail);